import { animate, state, style, transition, trigger } from "@angular/animations";


export const errorState =
trigger('errorState', [
    state('hidden', style({
        opacity: 0
    })),
    state('visible', style({
        opacity: 1
    })),
    transition('visible => hidden', animate('400ms ease-in')),
    transition('hidden => visible', animate('400ms ease-out'))
])

